export const defaultTag='#CDGVN #ChoDen #GundamVN #RoyalToysTool'